export default[
    {
        path: '/orderInfo',
        name: '/orderInfo',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '订单列表',
            keepAlive: false
        }
    }
]